__turbopack_context__.v({
  "caption": "styles-module-scss-module__Yatylq__caption",
  "header": "styles-module-scss-module__Yatylq__header",
  "icon": "styles-module-scss-module__Yatylq__icon",
  "root": "styles-module-scss-module__Yatylq__root",
});
